const text = {
  600: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: 1.2,
    "@media screen and (min-width: 40em)": {
      fontSize: "24px",
    },
  },
  500: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: 1.25,
    "@media screen and (min-width: 40em)": {
      fontSize: "18px",
    },
  },
  400: {
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: 1.25,
    "@media screen and (min-width: 40em)": {
      fontSize: "16px",
    },
  },
  300: {
    fontSize: "12px",
    fontWeight: "normal",
    lineHeight: 1.25,
    "@media screen and (min-width: 40em)": {
      fontSize: "14px",
    },
  },
}

export default text
